export default __webpack_public_path__ + "static/media/linkedin.c1b09f9e.svg";